import { Routes } from '@angular/router';
import { permissionGuard } from '../../core/auth/permission.guard';
import { FCC_PLATFORM_ENTITLEMENT } from './fcc-form.models';

const adminScope = { requiredScopes: ['admin'] as const };

export const FCC_ROUTES: Routes = [
  {
    path: 'fcc/settings',
    loadComponent: () => import('./fcc-settings.component').then(m => m.FccSettingsComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'fcc.config.read',
      requiredEntitlement: FCC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  },
  {
    path: 'fcc/settings/connectors',
    loadComponent: () => import('./fcc-connectors.component').then(m => m.FccConnectorsComponent),
    canActivate: [permissionGuard],
    data: {
      requiredPermission: 'fcc.connectors.manage',
      requiredEntitlement: FCC_PLATFORM_ENTITLEMENT,
      ...adminScope
    }
  }
];
